import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const TicketQRCodesForm = () => {
  const { page, updatePage } = usePage();

  return (
    <>
      <Form
        enableReinitialize
        initialValues={{
          eventDetails: {
            ...page?.eventDetails,
            // We default nullish values to false.
            // This ensures events without pdfTicketsEnabled are disabled.
            pdfTicketsEnabled: page?.eventDetails?.pdfTicketsEnabled ?? false,
            singleTicketPerPagePdfEnabled:
              page?.eventDetails?.singleTicketPerPagePdfEnabled ?? false,
          },
        }}
        fields={() => [
          {
            name: 'eventDetails.pdfTicketsEnabled',
            type: 'checkbox',
            label: 'Send ticket QR codes as a PDF',
          },
          {
            name: 'eventDetails.singleTicketPerPagePdfEnabled',
            type: 'checkbox',
            label: 'Use one page per ticket',
          },
        ]}
        onSubmit={async (values, actions) => {
          const { data, error } = await updatePage.mutateAsync(values);

          if (data) {
            actions.resetForm({
              values: {
                ...values,
              },
            });
          }

          return {
            data,
            error,
          };
        }}
      />
    </>
  );
};

export default TicketQRCodesForm;
